module.exports = __webpack_public_path__ + "media/src/images/mails/facebook-13136e850b4295af47ea7f984e31aa26.png";